import { Validators } from '@angular/forms';
import { prop, required, compose  } from '@rxweb/reactive-form-validators';
import { CustomValidators } from '../../extensions/custom-validators';
import { PersonType } from '../enums/person-type.enum';

export class ResponsibleData {
    constructor(entity?: Partial<ResponsibleData>) {
        Object.assign(this, entity);
    }

    @required()
    name: string;

    @compose({ validators: [Validators.required, CustomValidators.isValidCPF] })
    document: string;

    @required()
    position: string;

    @compose({ validators: [ Validators.required, Validators.requiredTrue] })
    agreement: boolean;

    @prop()
    rawFingerprint;
}
